<template>
  <v-app>
    <CargaInicial v-if="!autenticación.cargaInicial"></CargaInicial>

		<Interfaz v-else-if="autenticación.cargaInicial && autenticación.cuenta && autenticación.cuenta.identificador && autenticación.usuario && autenticación.usuario.identificador"></Interfaz>

		<IniciarSesion v-else></IniciarSesion>

		<!-- Mensajes: -->
		<v-snackbar
			v-model="notificación.mensaje.activo"
			:color="notificación.mensaje.color"
			timeout="20000"
		>
			{{ notificación.mensaje.descripción }}
			<v-btn
				text
				@click="notificación.mensaje.activo = false"
			>
				Cerrar
			</v-btn>
		</v-snackbar>
		<!-- Fin de mensajes -->
  </v-app>
</template>

<script>
import CargaInicial from './views/CargaInicial';
import IniciarSesion from './views/IniciarSesion';
import Interfaz from './views/Interfaz';
import { autenticación } from '@/../../cliente_comun/fuentes'
import { notificación } from '@/../../cliente_comun/utilidades'

export default {
  name: 'App',

  components: {
		CargaInicial,
		IniciarSesion,
		Interfaz,
  },

  data: () => ({
		notificación,
    autenticación
  }),
};
</script>
